export default __webpack_public_path__ + "static/media/CRM.17cf3733.png";